import AppleStoreBadgeImg from "../assets/AppleStoreBadge.svg";


const AppleStoreBadge = ({ className = "", ...props }) => (
    <a
        href="https://apps.apple.com/us/app/vespid/id6744089122"
        target="_blank"
        rel="noreferrer"
    >
        <img
            src={AppleStoreBadgeImg}
            alt="Apple Store Badge"
            loading="lazy"
            className={className}
            {...props}
        />
    </a>
);

export default AppleStoreBadge;
